// Google My Business Services - Common services across different business types

export const GMB_SERVICES = [
  // General Business Services
  'Consultation',
  'Free Consultation',
  'Appointment Scheduling',
  'Emergency Service',
  '24/7 Service',
  'Same Day Service',
  'Next Day Service',
  'Weekend Service',
  'Holiday Service',
  'Free Estimates',
  'Free Quotes',
  'Virtual Consultation',
  'In-Person Consultation',
  
  // Installation & Repair
  'Installation',
  'Repair',
  'Maintenance',
  'Inspection',
  'Diagnostics',
  'Troubleshooting',
  'Replacement',
  'Upgrade',
  'Refurbishment',
  'Restoration',
  
  // Design & Creative
  'Custom Design',
  'Graphic Design',
  'Logo Design',
  'Web Design',
  'Interior Design',
  'Landscape Design',
  'Architecture',
  'Consultation & Planning',
  '3D Rendering',
  'Prototyping',
  
  // Cleaning Services
  'Residential Cleaning',
  'Commercial Cleaning',
  'Deep Cleaning',
  'Move-in/Move-out Cleaning',
  'Post-Construction Cleaning',
  'Window Cleaning',
  'Carpet Cleaning',
  'Upholstery Cleaning',
  'Pressure Washing',
  'Sanitization',
  
  // Home Services
  'Plumbing',
  'Leak Repair',
  'Drain Cleaning',
  'Water Heater Installation',
  'Pipe Replacement',
  'Electrical Work',
  'Wiring',
  'Panel Upgrade',
  'Lighting Installation',
  'HVAC Installation',
  'AC Repair',
  'Heating Repair',
  'Duct Cleaning',
  'Roofing',
  'Roof Repair',
  'Roof Replacement',
  'Gutter Installation',
  'Painting',
  'Interior Painting',
  'Exterior Painting',
  'Carpentry',
  'Flooring Installation',
  'Tile Installation',
  'Drywall Repair',
  
  // Automotive Services
  'Oil Change',
  'Brake Service',
  'Tire Service',
  'Wheel Alignment',
  'Engine Diagnostics',
  'Transmission Repair',
  'Battery Replacement',
  'AC Repair',
  'Detailing',
  'Car Wash',
  'Waxing',
  'Paint Protection',
  'Window Tinting',
  'Body Work',
  'Dent Removal',
  'Collision Repair',
  'Towing',
  'Roadside Assistance',
  
  // Beauty & Wellness
  'Haircut',
  'Hair Coloring',
  'Hair Styling',
  'Blowout',
  'Hair Treatment',
  'Extensions',
  'Beard Trim',
  'Shave',
  'Manicure',
  'Pedicure',
  'Gel Nails',
  'Acrylic Nails',
  'Nail Art',
  'Facial',
  'Massage',
  'Swedish Massage',
  'Deep Tissue Massage',
  'Hot Stone Massage',
  'Waxing',
  'Threading',
  'Makeup Application',
  'Bridal Makeup',
  'Lash Extensions',
  'Microblading',
  'Tattoo',
  'Piercing',
  
  // Medical & Dental
  'General Checkup',
  'Physical Examination',
  'Preventive Care',
  'Diagnostic Testing',
  'Lab Work',
  'X-Ray',
  'Ultrasound',
  'MRI',
  'CT Scan',
  'Vaccination',
  'Immunization',
  'Dental Cleaning',
  'Dental Exam',
  'Teeth Whitening',
  'Fillings',
  'Root Canal',
  'Crowns',
  'Bridges',
  'Dentures',
  'Implants',
  'Orthodontics',
  'Braces',
  'Invisalign',
  'Physical Therapy',
  'Rehabilitation',
  'Chiropractic Care',
  'Acupuncture',
  
  // Fitness & Training
  'Personal Training',
  'Group Classes',
  'Yoga Classes',
  'Pilates',
  'Spin Class',
  'CrossFit',
  'Boxing',
  'Martial Arts',
  'Dance Classes',
  'Nutrition Counseling',
  'Meal Planning',
  'Weight Loss Program',
  'Strength Training',
  'Cardio Training',
  
  // Food & Beverage
  'Dine-In',
  'Takeout',
  'Delivery',
  'Catering',
  'Private Events',
  'Banquet Services',
  'Wedding Catering',
  'Corporate Catering',
  'Meal Prep',
  'Custom Cakes',
  'Bakery Services',
  'Coffee',
  'Espresso Bar',
  'Smoothies',
  'Juice Bar',
  
  // Photography & Video
  'Portrait Photography',
  'Wedding Photography',
  'Event Photography',
  'Commercial Photography',
  'Product Photography',
  'Real Estate Photography',
  'Headshots',
  'Photo Editing',
  'Video Production',
  'Videography',
  'Drone Photography',
  'Photo Booth Rental',
  
  // Real Estate
  'Property Management',
  'Home Buying',
  'Home Selling',
  'Rental Services',
  'Property Valuation',
  'Market Analysis',
  'Home Staging',
  'Virtual Tours',
  'Open House',
  'Investment Properties',
  
  // Legal & Financial
  'Legal Consultation',
  'Contract Review',
  'Document Preparation',
  'Estate Planning',
  'Will Preparation',
  'Trust Services',
  'Tax Preparation',
  'Tax Filing',
  'Bookkeeping',
  'Accounting',
  'Financial Planning',
  'Investment Advice',
  'Retirement Planning',
  'Insurance Services',
  'Notary Services',
  
  // Education & Training
  'Tutoring',
  'Test Prep',
  'Language Lessons',
  'Music Lessons',
  'Voice Lessons',
  'Instrument Lessons',
  'Dance Lessons',
  'Art Classes',
  'Cooking Classes',
  'Computer Training',
  'Professional Development',
  'Career Coaching',
  
  // Pet Services
  'Pet Grooming',
  'Dog Walking',
  'Pet Sitting',
  'Pet Boarding',
  'Dog Training',
  'Obedience Training',
  'Veterinary Care',
  'Pet Emergency Care',
  'Pet Dental Care',
  'Pet Surgery',
  'Pet Vaccination',
  
  // Event Services
  'Event Planning',
  'Wedding Planning',
  'Party Planning',
  'Venue Rental',
  'Equipment Rental',
  'Decoration',
  'DJ Services',
  'Live Music',
  'Entertainment',
  'Bartending',
  'Photography & Videography',
  'Invitation Design',
  'Floral Arrangements',
  
  // Technology Services
  'Computer Repair',
  'Laptop Repair',
  'Phone Repair',
  'Screen Replacement',
  'Data Recovery',
  'Virus Removal',
  'Software Installation',
  'Hardware Upgrade',
  'Network Setup',
  'IT Support',
  'Website Development',
  'App Development',
  'SEO Services',
  'Digital Marketing',
  'Social Media Management',
  
  // Moving & Storage
  'Residential Moving',
  'Commercial Moving',
  'Long Distance Moving',
  'Local Moving',
  'Packing Services',
  'Unpacking Services',
  'Loading & Unloading',
  'Storage',
  'Climate Controlled Storage',
  'Vehicle Storage',
  
  // Delivery & Logistics
  'Same Day Delivery',
  'Express Delivery',
  'Standard Delivery',
  'International Shipping',
  'Package Pickup',
  'Courier Service',
  'Freight Services',
  'White Glove Delivery'
];

// Sort alphabetically
export const SORTED_GMB_SERVICES = [...GMB_SERVICES].sort();

export default SORTED_GMB_SERVICES;




